import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Col, Button, Image } from "react-bootstrap";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  // ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import Switch from "react-switch";
import { NewInputText } from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { AddButtonIconComponent } from "../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../navigationSection/BottomNavigationMobile";
import { LearnMore } from "../../../../../superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/restaurantDetailsLogoVideo/SuperAdminAddRestaurantDetails";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  get_new_subscription_for_vendor,
  update_new_subscription_for_vendor,
} from "../../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import store from "../../../../../../store/store";
import { CLEAR_LOADER } from "../../../../../../store/types";

export const EditCasualLiveStreaming = (props) => {
  let history = useHistory();
  const [state, setState] = useState({
    casualLiveStreamingYoutube: false,
    casualLiveStreamingInstagram: false,
    casualLiveStreamingFacebook: false,
    casualLiveStreamingLinkdin: false,
    casualLiveStreamingYoutubeArr: [],
    casualLiveStreamingInstagramArr: [],
    casualLiveStreamingFacebookArr: [],
    casualLiveStreamingLinkdinArr: [],
    editButton: false,
    errors: {},
  });

  /************** @DESC FocusOut ****************/
  const onFocusOutLink = (e) => {
    const { errors } = state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
    } else {
      delete errors[e.target.name];
    }
    setState({
      ...state,
      errors: errors,
      error: Object.keys(errors).length > 0 ? true : false,
      actionButton: true,
    });
  };

  /************** @DESC Switch Button Handler ****************/
  const casualDiningInsideOfflineEventHandler = (type) => (e) => {
    if (type === "eventYoutubeLink") {
      setState({
        ...state,
        casualLiveStreamingYoutube: !state.casualLiveStreamingYoutube,
        casualLiveStreamingYoutubeArr: [
          {
            url: "",
            area: "",
          },
        ],
        errors: {},
      });
    } else if (type === "eventInstagramLink") {
      setState({
        ...state,
        casualLiveStreamingInstagram: !state.casualLiveStreamingInstagram,
        casualLiveStreamingInstagramArr: [
          {
            url: "",
            area: "",
          },
        ],
        errors: {},
      });
    } else if (type === "eventFacebookLink") {
      setState({
        ...state,
        casualLiveStreamingFacebook: !state.casualLiveStreamingFacebook,
        casualLiveStreamingFacebookArr: [
          {
            url: "",
            area: "",
          },
        ],
        errors: {},
      });
    } else if (type === "eventLinkdinLink") {
      setState({
        ...state,
        casualLiveStreamingLinkdin: !state.casualLiveStreamingLinkdin,
        casualLiveStreamingLinkdinArr: [
          {
            url: "",
            area: "",
          },
        ],
        errors: {},
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Youtube Handlers
   ******************************************/
  const onAddYoutubeHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingYoutubeArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        area: "",
      });
      setState({
        ...state,
        casualLiveStreamingYoutubeArr: linkDesc,
      });
    }
  };

  const onYoutubeChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualLiveStreamingYoutubeArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].area = e.target.value;
    }
    setState({
      ...state,
      casualLiveStreamingYoutubeArr: linkDesc,
    });
  };

  const onYoutubeDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingYoutubeArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualLiveStreamingYoutubeArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Instagram Handlers
   ******************************************/
  const onAddInstagramHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingInstagramArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        area: "",
      });
      setState({
        ...state,
        casualLiveStreamingInstagramArr: linkDesc,
      });
    }
  };

  const onInstagramChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualLiveStreamingInstagramArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].area = e.target.value;
    }
    setState({
      ...state,
      casualLiveStreamingInstagramArr: linkDesc,
    });
  };

  const onInstagramDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingInstagramArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualLiveStreamingInstagramArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Facebook Handlers
   ******************************************/
  const onAddFacebookHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingFacebookArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        area: "",
      });
      setState({
        ...state,
        casualLiveStreamingFacebookArr: linkDesc,
      });
    }
  };

  const onFacebookChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualLiveStreamingFacebookArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].area = e.target.value;
    }
    setState({
      ...state,
      casualLiveStreamingFacebookArr: linkDesc,
    });
  };

  const onFacebookDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingFacebookArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualLiveStreamingFacebookArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Linkedin Handlers
   ******************************************/
  const onAddLinkdinHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingLinkdinArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].area === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.area = `*Fields can’t be blank. Please enter your area`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        area: "",
      });
      setState({
        ...state,
        casualLiveStreamingLinkdinArr: linkDesc,
      });
    }
  };

  const onLinkdinChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualLiveStreamingLinkdinArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "business") {
      linkDesc[index].area = e.target.value;
    }
    setState({
      ...state,
      casualLiveStreamingLinkdinArr: linkDesc,
    });
  };

  const onLinkdinDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualLiveStreamingLinkdinArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualLiveStreamingLinkdinArr: linkDesc });
    }
  };

  useEffect(() => {
    if (props && props.subscriptionData) {
      let data = props.subscriptionData;
      setState({
        ...state,
        casualLiveStreamingYoutube:
          props.subscriptionData.youtube.value === undefined
            ? state.casualLiveStreamingYoutube
            : props.subscriptionData.youtube.value,
        casualLiveStreamingInstagram:
          props.subscriptionData.instagram.value === undefined
            ? state.casualLiveStreamingInstagram
            : props.subscriptionData.instagram.value,
        casualLiveStreamingFacebook:
          props.subscriptionData.facebook.value === undefined
            ? state.casualLiveStreamingFacebook
            : props.subscriptionData.facebook.value,
        casualLiveStreamingLinkdin:
          props.subscriptionData.linkedin.value === undefined
            ? state.casualLiveStreamingLinkdin
            : props.subscriptionData.linkedin.value,
        casualLiveStreamingYoutubeArr:
          props.subscriptionData.youtube.sub_values === undefined
            ? state.casualLiveStreamingYoutubeArr
            : props.subscriptionData.youtube.sub_values,
        casualLiveStreamingInstagramArr:
          props.subscriptionData.instagram.sub_values === undefined
            ? state.casualLiveStreamingInstagramArr
            : props.subscriptionData.instagram.sub_values,
        casualLiveStreamingFacebookArr:
          props.subscriptionData.facebook.sub_values === undefined
            ? state.casualLiveStreamingFacebookArr
            : props.subscriptionData.facebook.sub_values,
        casualLiveStreamingLinkdinArr:
          props.subscriptionData.linkedin.sub_values === undefined
            ? state.casualLiveStreamingLinkdinArr
            : props.subscriptionData.linkedin.sub_values,
      });
    }
  }, [props.subscriptionData]);

  // useEffect(() => {
  //   let formDataId = {
  //     vendor_id: props.auth.user.VendorUser._id,
  //   };
  //   props.get_new_subscription_for_vendor(formDataId);
  //   store.dispatch({
  //     type: CLEAR_LOADER,
  //   });
  // });

  const insideLiveStreamingSubmitClick = (e) => {
    let valuesData = {
      // value:
      //   state.casualLiveStreamingYoutube ||
      //   state.casualLiveStreamingInstagram ||
      //   state.casualLiveStreamingFacebook ||
      //   state.casualLiveStreamingLinkdin
      //     ? true
      //     : false,
      value: true,
      youtube: {
        value: state.casualLiveStreamingYoutube,
        sub_values: state.casualLiveStreamingYoutubeArr,
      },
      instagram: {
        value: state.casualLiveStreamingInstagram,
        sub_values: state.casualLiveStreamingInstagramArr,
      },
      facebook: {
        value: state.casualLiveStreamingFacebook,
        sub_values: state.casualLiveStreamingFacebookArr,
      },
      linkedin: {
        value: state.casualLiveStreamingLinkdin,
        sub_values: state.casualLiveStreamingLinkdinArr,
      },
    };
    const token = props.auth.user.accessToken;
    const subscriptionId = props?.subscription?._id;
    let formData = props?.allSubscriptionsData;
    if (props?.casualDiningService) {
      formData.casual_dining_status.live_streaming = valuesData;
    } else if (props?.fastFoodDiningService) {
      formData.fast_food_dining_status.live_streaming = valuesData;
    } else if (props?.multiDiningService) {
      formData.multi_service_business_status.live_streaming = valuesData;
    }
    props.update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Live Streaming subscription edited successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/profile");
  };

  const [disabled, setDisable] = useState(true);
  const [disabledOne, setDisableOne] = useState(true);
  const [disabledTwo, setDisableTwo] = useState(true);
  const [disabledThree, setDisableThree] = useState(true);
  const onEditButtonOnClick = (e) => {
    setDisable(!disabled);
  };
  const onEditButtonOnClickOne = (e) => {
    setDisableOne(!disabledOne);
  };
  const onEditButtonOnClickTwo = (e) => {
    setDisableTwo(!disabledTwo);
  };
  const onEditButtonOnClickThree = (e) => {
    setDisableThree(!disabledThree);
  };

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div
                className="col-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0 pl-3"
                style={{ overflowX: "hidden" }}
              >
                <div className="mb-4">
                  <TopTextReusableComponent
                    headingText="Live Streaming"
                    headingParagraph="By enabling this option you can have a live stream of various different areas of your business establishment on the user app. User can see the live ambience and hygiene of your business. You can use it on front desk, in the kitchen area, and for the dining area. You can enter different URLs for your different social media pages."
                    // displayEdit={state.editButton}
                    // onClickEdit={editClick}
                  />
                </div>
                <div className="row margin-between-toggler inside-event-offline-online-text mt-4 mb-4">
                  <div className="col-8">
                    <div className="f14-500">Youtube</div>
                    {/* <div className="f11-400 opacity5">
                      Enter your live streaming information for event below
                    </div> */}
                  </div>
                  <div className="col-2">
                    <Switch
                      checked={state.casualLiveStreamingYoutube}
                      onChange={casualDiningInsideOfflineEventHandler(
                        "eventYoutubeLink"
                      )}
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={16}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={10}
                      width={27}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                      // disabled={disabled}
                    />
                  </div>
                  {/* {disabled ? (
                    <div className="col-2">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => onEditButtonOnClick()}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
                {state.casualLiveStreamingYoutube ? (
                  <React.Fragment>
                    {state.casualLiveStreamingYoutubeArr.map((data, index) => (
                      <div
                        className="row inside-event-offline-online-text mb-5 align-items-center"
                        key={index}
                      >
                        <div className="col-10">
                          <div className="row mt-4">
                            <Col md={7}>
                              <NewInputText
                                extraClass="mb-0"
                                name="url"
                                inputType="text"
                                onFocusOut={onFocusOutLink}
                                onChange={onYoutubeChangeHandler("link", index)}
                                maxLength="50"
                                value={data.url}
                                // disabled={disabled}
                                labelText="Stream URL"
                                errorText={
                                  data.url === "" &&
                                  state.errors.url ===
                                    "*Fields can’t be blank. Please enter your url"
                                    ? "*Fields can’t be blank. Please enter your Stream URL"
                                    : null
                                }
                                errorTrue={
                                  data.url === "" &&
                                  state.errors.url ===
                                    "*Fields can’t be blank. Please enter your url"
                                    ? true
                                    : false
                                }
                                controlClass={
                                  data.url === "" &&
                                  state.errors.url ===
                                    "*Fields can’t be blank. Please enter your url"
                                    ? "outlined-error-helper-text"
                                    : "outlined-helperText "
                                }
                              />
                            </Col>
                            <Col md={4}>
                              <NewInputText
                                extraClass="mb-0 w-100"
                                name="area"
                                inputType="text"
                                // disabled={disabled}
                                onFocusOut={onFocusOutLink}
                                onChange={onYoutubeChangeHandler(
                                  "business",
                                  index
                                )}
                                maxLength="50"
                                value={data.area}
                                labelText="Area of Facility"
                                errorText={
                                  data.area === "" &&
                                  state.errors.area ===
                                    "*Fields can’t be blank. Please enter your area"
                                    ? "*Fields can’t be blank. Please enter your Area of Facility"
                                    : null
                                }
                                errorTrue={
                                  data.area === "" &&
                                  state.errors.area ===
                                    "*Fields can’t be blank. Please enter your area"
                                    ? true
                                    : false
                                }
                                controlClass={
                                  data.area === "" &&
                                  state.errors.area ===
                                    "*Fields can’t be blank. Please enter your area"
                                    ? "outlined-error-helper-text"
                                    : "outlined-helperText "
                                }
                              />
                            </Col>
                            {state.casualLiveStreamingYoutubeArr.length > 1 ? (
                              <div className="col-1 restaurant_details_onboarding_minus_button align-items-start pt-2">
                                <div>
                                  <AddButtonIconComponent
                                    // buttonText="Delete"
                                    onClick={onYoutubeDeleteHandler(index)}
                                    fontIcon="fa fa-trash-o"
                                    colorCss="delete"
                                    // disabled={disabled}
                                  />
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="col-12 p-0 mb-4 restaurant_details_onboarding_minus_button add_email_button flex-wrap">
                      {
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddYoutubeHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                            // disabled={disabled}
                          />
                        </div>
                      }
                      <hr />
                    </div>
                  </React.Fragment>
                ) : null}

                <div className="row margin-between-toggler inside-event-offline-online-text mb-4">
                  <div className="col-8">
                    <div className="f14-500">Instagram</div>
                    {/* <div className="f11-400 opacity5">
                      Enter your live streaming information for event below
                    </div> */}
                  </div>
                  <div className="col-2">
                    <Switch
                      checked={state.casualLiveStreamingInstagram}
                      onChange={casualDiningInsideOfflineEventHandler(
                        "eventInstagramLink"
                      )}
                      // disabled={disabledOne}
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={16}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={10}
                      width={27}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                    />
                  </div>
                  {/* {disabledOne ? (
                    <div className="col-2">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => onEditButtonOnClickOne()}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
                {state.casualLiveStreamingInstagram ? (
                  <React.Fragment>
                    {state.casualLiveStreamingInstagramArr.map(
                      (data, index) => (
                        <div
                          className="row inside-event-offline-online-text mb-5 align-items-center"
                          key={index}
                        >
                          <div className="col-10">
                            <div className="row mt-4">
                              <Col md={7}>
                                <NewInputText
                                  // disabled={disabledOne}
                                  extraClass="mb-0"
                                  name="url"
                                  inputType="text"
                                  onFocusOut={onFocusOutLink}
                                  onChange={onInstagramChangeHandler(
                                    "link",
                                    index
                                  )}
                                  maxLength="50"
                                  value={data.url}
                                  labelText="Stream URL"
                                  errorText={
                                    data.url === "" &&
                                    state.errors.url ===
                                      "*Fields can’t be blank. Please enter your url"
                                      ? "*Fields can’t be blank. Please enter your Stream URL"
                                      : null
                                  }
                                  errorTrue={
                                    data.url === "" &&
                                    state.errors.url ===
                                      "*Fields can’t be blank. Please enter your url"
                                      ? true
                                      : false
                                  }
                                  controlClass={
                                    data.url === "" &&
                                    state.errors.url ===
                                      "*Fields can’t be blank. Please enter your url"
                                      ? "outlined-error-helper-text"
                                      : "outlined-helperText "
                                  }
                                />
                                <div className="f11-400 opacity5">
                                  Anyone using these links can watch the live
                                  stream, any violation is subject to review and
                                  flagging the account.
                                </div>
                              </Col>
                              <Col md={4}>
                                <NewInputText
                                  extraClass="mb-0"
                                  name="area"
                                  inputType="text"
                                  onFocusOut={onFocusOutLink}
                                  onChange={onInstagramChangeHandler(
                                    "business",
                                    index
                                  )}
                                  // disabled={disabledOne}
                                  maxLength="50"
                                  value={data.area}
                                  labelText="Area of Facility"
                                  errorText={
                                    data.area === "" &&
                                    state.errors.area ===
                                      "*Fields can’t be blank. Please enter your area"
                                      ? "*Fields can’t be blank. Please enter your Area of Facility"
                                      : null
                                  }
                                  errorTrue={
                                    data.area === "" &&
                                    state.errors.area ===
                                      "*Fields can’t be blank. Please enter your area"
                                      ? true
                                      : false
                                  }
                                  controlClass={
                                    data.area === "" &&
                                    state.errors.area ===
                                      "*Fields can’t be blank. Please enter your area"
                                      ? "outlined-error-helper-text"
                                      : "outlined-helperText "
                                  }
                                />
                              </Col>
                              <div className="col-1 pt-2">
                                {state.casualLiveStreamingInstagramArr.length >
                                1 ? (
                                  // disabledOne ? (
                                  //   ""
                                  // ) :
                                  <div className="restaurant_details_onboarding_minus_button">
                                    <div>
                                      <AddButtonIconComponent
                                        // buttonText="Delete"
                                        onClick={onInstagramDeleteHandler(
                                          index
                                        )}
                                        fontIcon="fa fa-trash-o"
                                        colorCss="delete"
                                        // disabled={disabledOne}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                    <div className="col-12 p-0 mb-4 restaurant_details_onboarding_minus_button add_email_button flex-wrap">
                      {
                        // disabledOne ? (
                        //   ""
                        // ) :
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddInstagramHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                            // disabled={disabledOne}
                          />
                        </div>
                      }
                      <hr />
                    </div>
                  </React.Fragment>
                ) : null}

                <div className="row margin-between-toggler inside-event-offline-online-text mb-4">
                  <div className="col-8">
                    <div className="f14-500">Facebook</div>
                    {/* <div className="f11-400 opacity5">
                      Enter your live streaming information for event below
                    </div> */}
                  </div>
                  <div className="col-2">
                    <Switch
                      checked={state.casualLiveStreamingFacebook}
                      onChange={casualDiningInsideOfflineEventHandler(
                        "eventFacebookLink"
                      )}
                      // disabled={disabledTwo}
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={16}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={10}
                      width={27}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                    />
                  </div>
                  {/* {disabledTwo ? (
                    <div className="col-2">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => onEditButtonOnClickTwo()}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
                {state.casualLiveStreamingFacebook ? (
                  <React.Fragment>
                    {state.casualLiveStreamingFacebookArr.map((data, index) => (
                      <div
                        className="row inside-event-offline-online-text mb-5 align-items-center"
                        key={index}
                      >
                        <div className="col-10">
                          <div className="row mt-4">
                            <Col md={7}>
                              <NewInputText
                                extraClass="mb-0"
                                name="url"
                                inputType="text"
                                onFocusOut={onFocusOutLink}
                                onChange={onFacebookChangeHandler(
                                  "link",
                                  index
                                )}
                                // disabled={disabledTwo}
                                maxLength="50"
                                value={data.url}
                                labelText="Stream URL"
                                errorText={
                                  data.url === "" &&
                                  state.errors.url ===
                                    "*Fields can’t be blank. Please enter your url"
                                    ? "*Fields can’t be blank. Please enter your Stream URL"
                                    : null
                                }
                                errorTrue={
                                  data.url === "" &&
                                  state.errors.url ===
                                    "*Fields can’t be blank. Please enter your url"
                                    ? true
                                    : false
                                }
                                controlClass={
                                  data.url === "" &&
                                  state.errors.url ===
                                    "*Fields can’t be blank. Please enter your url"
                                    ? "outlined-error-helper-text"
                                    : "outlined-helperText "
                                }
                              />
                            </Col>
                            <Col md={4}>
                              <NewInputText
                                extraClass="mb-0"
                                name="area"
                                inputType="text"
                                onFocusOut={onFocusOutLink}
                                onChange={onFacebookChangeHandler(
                                  "business",
                                  index
                                )}
                                // disabled={disabledTwo}
                                maxLength="50"
                                value={data.area}
                                labelText="Area of Facility"
                                errorText={
                                  data.area === "" &&
                                  state.errors.area ===
                                    "*Fields can’t be blank. Please enter your area"
                                    ? "*Fields can’t be blank. Please enter your Area of Facility"
                                    : null
                                }
                                errorTrue={
                                  data.area === "" &&
                                  state.errors.area ===
                                    "*Fields can’t be blank. Please enter your area"
                                    ? true
                                    : false
                                }
                                controlClass={
                                  data.area === "" &&
                                  state.errors.area ===
                                    "*Fields can’t be blank. Please enter your area"
                                    ? "outlined-error-helper-text"
                                    : "outlined-helperText "
                                }
                              />
                            </Col>
                            <div className="col-1 pt-2">
                              {state.casualLiveStreamingFacebookArr.length >
                              1 ? (
                                // disabledTwo ? (
                                //   ""
                                // ) :
                                <div className="restaurant_details_onboarding_minus_button">
                                  <div>
                                    <AddButtonIconComponent
                                      // buttonText="Delete"
                                      onClick={onFacebookDeleteHandler(index)}
                                      fontIcon="fa fa-trash-o"
                                      colorCss="delete"
                                      // disabled={disabledTwo}
                                    />
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="col-12 p-0 mb-4 restaurant_details_onboarding_minus_button add_email_button  flex-wrap">
                      {
                        // disabledTwo ? (
                        //   ""
                        // ) :
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddFacebookHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                            // disabled={disabledTwo}
                          />
                        </div>
                      }
                      <hr />
                    </div>
                  </React.Fragment>
                ) : null}

                <div className="row margin-between-toggler inside-event-offline-online-text mb-5">
                  <div className="col-8">
                    <div className="f14-500">Linkedin</div>
                    {/* <div className="f11-400 opacity5">
                      Enter your live streaming information for event below
                    </div> */}
                  </div>
                  <div className="col-2">
                    <Switch
                      checked={state.casualLiveStreamingLinkdin}
                      onChange={casualDiningInsideOfflineEventHandler(
                        "eventLinkdinLink"
                      )}
                      // disabled={disabledThree}
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={16}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={10}
                      width={27}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                    />
                  </div>
                  {/* {disabledThree ? (
                    <div className="col-2">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => onEditButtonOnClickThree()}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>
                {state.casualLiveStreamingLinkdin ? (
                  <React.Fragment>
                    {state.casualLiveStreamingLinkdinArr.map((data, index) => (
                      <div
                        className="row inside-event-offline-online-text mb-5 align-items-center"
                        key={index}
                      >
                        <div className="col-10">
                          <div className="row mt-4">
                            <Col md={7}>
                              <NewInputText
                                extraClass="mb-0"
                                name="url"
                                inputType="text"
                                onFocusOut={onFocusOutLink}
                                onChange={onLinkdinChangeHandler("link", index)}
                                maxLength="50"
                                value={data.url}
                                // disabled={disabledThree}
                                labelText="Stream URL"
                                errorText={
                                  data.url === "" &&
                                  state.errors.url ===
                                    "*Fields can’t be blank. Please enter your url"
                                    ? "*Fields can’t be blank. Please enter your Stream URL"
                                    : null
                                }
                                errorTrue={
                                  data.url === "" &&
                                  state.errors.url ===
                                    "*Fields can’t be blank. Please enter your url"
                                    ? true
                                    : false
                                }
                                controlClass={
                                  data.url === "" &&
                                  state.errors.url ===
                                    "*Fields can’t be blank. Please enter your url"
                                    ? "outlined-error-helper-text"
                                    : "outlined-helperText "
                                }
                              />
                            </Col>
                            <Col md={4}>
                              <NewInputText
                                extraClass="mb-0"
                                name="area"
                                inputType="text"
                                onFocusOut={onFocusOutLink}
                                onChange={onLinkdinChangeHandler(
                                  "business",
                                  index
                                )}
                                maxLength="50"
                                value={data.area}
                                // disabled={disabledThree}
                                labelText="Area of Facility"
                                errorText={
                                  data.area === "" &&
                                  state.errors.area ===
                                    "*Fields can’t be blank. Please enter your area"
                                    ? "*Fields can’t be blank. Please enter your Area of Facility"
                                    : null
                                }
                                errorTrue={
                                  data.area === "" &&
                                  state.errors.area ===
                                    "*Fields can’t be blank. Please enter your area"
                                    ? true
                                    : false
                                }
                                controlClass={
                                  data.area === "" &&
                                  state.errors.area ===
                                    "*Fields can’t be blank. Please enter your area"
                                    ? "outlined-error-helper-text"
                                    : "outlined-helperText "
                                }
                              />
                            </Col>
                            <div className="col-1 pt-2">
                              {state.casualLiveStreamingLinkdinArr.length >
                              1 ? (
                                // disabledThree ? (
                                //   ""
                                // ) :
                                <div className="restaurant_details_onboarding_minus_button">
                                  <div>
                                    <AddButtonIconComponent
                                      // buttonText="Delete"
                                      onClick={onLinkdinDeleteHandler(index)}
                                      fontIcon="fa fa-trash-o"
                                      colorCss="delete"
                                      // disabled={disabledThree}
                                    />
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div className="col-12 p-0 mb-4 restaurant_details_onboarding_minus_button add_email_button flex-wrap mb-5">
                      {
                        // disabledThree ? (
                        //   ""
                        // ) :
                        <div>
                          <AddButtonIconComponent
                            buttonText="Add another streaming link for different area"
                            onClick={onAddLinkdinHandler}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                            // disabled={disabledThree}
                          />
                        </div>
                      }
                      <hr />
                    </div>
                  </React.Fragment>
                ) : null}
                <div className="row mb-5">
                  <div className="col-12">
                    <LearnMore
                      buttonClass={"f12-400 opacity5"}
                      preText={`Anyone using these links can watch the live stream, any violation is subject to review and flagging the account  `}
                      learnMoreDefault={true}
                      buttonDisplay={true}
                      buttonText={"Terms & Conditions"}
                      mainContent={
                        <>
                          <div className="f12-400 opacity5 mb-4">
                            Live Streaming – Merchant Terms
                          </div>
                          <div className="f12-400 opacity5 mb-4">
                            The Live streaming service, if subscribed allows the
                            Merchant to stream different areas of the restaurant
                            like the Kitchen, Dining area, Front desk through
                            live streaming which is supported via social media
                            platforms such as YouTube, Instagram, Facebook and
                            LinkedIn platforms. Merchant has to subscribe to one
                            of these social media platforms to avail the live
                            streaming service from Amealio. This facilitates
                            Merchant to use the recording from the live
                            streaming to be casted on their social media at
                            their own responsibility. Amealio and its platform
                            do not intervene or moderate the live streaming
                            recordings if any. The Live streaming service and
                            the related terms thereof are only applicable for
                            the Merchants who opt for this Service. Merchant can
                            turn on/off this feature from the session settings
                            of their dashboard. Accordingly, Users will be
                            notified that Merchant’s premises are on live
                            streaming. The Merchant shall choose a streaming
                            platform and provide a link for the live streaming.
                            The live streaming service must not be used to
                            mislead Users that specific footage is occurring in
                            real time when it is not and/or is happening in a
                            particular location when it is not. The Merchant
                            acknowledges and affirms that:- When subscribing for
                            the live streaming he has the right to display,
                            record, shoot, film, portray, reproduce or stream
                            the location/ areas of the restaurants, any
                            copyrighted, trademarked or patented content,
                            products or technology used via such live streaming.
                            That the content being livestreamed is original and
                            he has a right to use such content for commercial
                            purposes. That he has the lawful consent or
                            permission to record of any person appearing in the
                            live stream. The Merchant has taken all reasonable
                            steps to display proper notice about the live
                            streaming being conducted at the Restaurant premises
                            and obtained the lawful consent and permission of
                            the Diners/ Customers appearing in the live stream.
                            The Merchant affirms that he is compliant to all the
                            health and safety guidelines or measures while live
                            streaming. Amealio is merely a Platform and not the
                            owner, actor or participant in/of the content and
                            thus shall not be liable for any objections raised
                            by the concerned authorities or the viewers. If
                            Amealio, either on its own or upon receiving a
                            complaint from the User or any concerned party
                            thereof, observes that there exists reasonable
                            grounds to believe that the live content being
                            streamed is defamatory, abusive, harassing,
                            insulting, threatening, illegal, bigoted, hateful
                            violent, vulgar, infringed, obscene in any manner or
                            to any person or community, Amealio may immediately
                            prohibit the streaming of such content via its
                            Platform and may suspend the Merchant’s live
                            streaming services. Amealio may at its sole
                            discretion even flag or suspend the Merchant’s
                            account until a proper explanation alongwith
                            cessation of activity is done by the Merchant. The
                            Merchant while subscribing the live streaming
                            feature provides Amealio with the irrevocable right
                            to stream, display, reproduce, access the content
                            therein, unless the Merchant revokes the
                            subscription of this service. Notwithstanding the
                            agreement with Amealio, the content feature and the
                            content therein are subject to the Community
                            Guidelines, Terms and conditions of the streaming
                            platforms such as YouTube, Instagram, Facebook,
                            LinkedIn and the laws of applicable jurisdiction. In
                            the event, the live streaming recordings are
                            required by law, regulation, Governmental authority
                            or body or order of relevant court of law or
                            tribunal for any reason, it shall be the sole
                            responsibility of the Merchant to provide such live
                            streaming recordings as and when called upon to do
                            so. The Live streaming content is continuously
                            moderated by the platforms like Youtube, Instagram,
                            Facebook Live, LinkedIn, and others as per their
                            polices and guidelines. These platform can flag the
                            content or stop the service at the anytime and the
                            Amealio reserves the right to add and/or change the
                            list of social media platforms for live streaming
                            service at anytime, with intimation to the Merchants
                            atleast 30 days prior to the date of such change.
                          </div>
                        </>
                      }
                    />
                  </div>
                </div>
                <div className="onboarding-map-setup-screen-autodetect-button">
                  <ReusableOnboardingButton
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    buttonType="button"
                    onClick={(e) => history.push("/profile")}
                  />
                  {/* {disabled === false ||
                  disabledOne === false ||
                  disabledTwo === false ||
                  disabledThree === false ? ( */}
                  <ReusableOnboardingButton
                    buttonTitle="Next Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Done"
                    buttonType="button"
                    onClick={insideLiveStreamingSubmitClick}
                  />
                  {/* ) : (
                    ""
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

EditCasualLiveStreaming.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state.onboarding && state.onboarding.onboard_subscription_details,
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  subscriptionData:
    state?.onboarding?.onboard_subscription_details?.casual_dining &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
          ?.live_streaming
      : state?.onboarding?.onboard_subscription_details?.fast_food_dining &&
        state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
      ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
          ?.live_streaming
      : state?.onboarding?.onboard_subscription_details
          ?.multi_service_business_status?.live_streaming,
  allSubscriptionsData:
    state.onboarding && state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  get_new_subscription_for_vendor,
})(withRouter(EditCasualLiveStreaming));
